import styled from 'styled-components';
import Image from 'next/image';

interface TestimonialSectionProps {
  bgColor?: string;
  imageUrl: string;
  quoteText: string;
  author: string;
  imageAlt: string;
}

const TestimonialSection: React.FC<TestimonialSectionProps> = ({ bgColor, imageUrl, quoteText, author, imageAlt }) => {
  return (
    <SectionContainer bgColor={bgColor} aria-label="Testimonial Section">
      <ContentContainer>
        <TextBlock aria-label="Testimonial Text">
          <blockquote>{quoteText}</blockquote>
          <p>{author}</p>
        </TextBlock>
        <ImageBlock aria-label="Person Image">
          <Image src={imageUrl} alt={imageAlt} layout="fill" objectFit="cover" quality={100} />
        </ImageBlock>
      </ContentContainer>
    </SectionContainer>
  );
};

const ContentContainer = styled.section<{ bgColor?: string }>`
  max-width: 1350px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  column-gap: 200px;
`;

const SectionContainer = styled.section<{ bgColor?: string }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${(props) => props.bgColor || '#fff'};
  padding: 40px;
  padding: 200px 0;
`;

const TextBlock = styled.div`
  max-width: 50%;
  font-size: 1.2rem;
  line-height: 1.6;
  max-width: 564px;
  padding-top: 100px;

  blockquote {
    font-size: 1.5rem;
    font-family: 'alliance_no.2bold';
    font-weight: 700;
    font-size: 28px;
    line-height: 37px;
  }

  p {
    margin-top: 40px;
    font-family: 'Alliance No.2';
    font-weight: 300;
    font-size: 20px;
    line-height: 20px;
  }
`;

const ImageBlock = styled.div`
  max-width: 40%;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  width: 586px;
  height: 586px;
  width: 586px;

  img {
    border-radius: 100px 10px 100px 10px;
  }
`;

export default TestimonialSection;
